module.exports = __webpack_public_path__ + "static/media/Alomran.9fd80810.jpeg";